import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  bgGeneral: {
    backgroundColor: '#FFFFFF',
    height: '645px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 100%',
  },
  chartBarDonutTitle: {
    fontWeight: 600,
    color: '#42526E',
    fontSize: '1.2rem'
  },
  skipButton: {
    backgroundColor: '#ffffff',
    color: '#024787',
    borderColor: '#024787',
    border: '2px solid',
    marginRight: '8px',
    height: '40px',
    width: '160px',
    borderRadius: '64px',
    '&:hover': {
      backgroundColor: '#dddddd',
    },
  },
  beginButton: {
    backgroundColor: '#024787',
    marginLeft: 1,
    height: '40px',
    width: '160px',
    borderRadius: '64px',
    '&:hover': {
      backgroundColor: '#2579c7',
    },
  },
  finishButton: {
    backgroundColor: '#024787',
    ml: 1,
    height: '40px',
    width: '160px',
    borderRadius: '64px',
    '&:hover': {
      backgroundColor: '#2579c7',
    },
  },
  boxCashPerDay: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  chartBarCost: {
    height: 190,
    padding: 0,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
    },
    [theme.breakpoints.up('lg')]: {
      alignItems: 'flex-end',
      // marginTop: '20px'
    },
  },
  chartBarPerformance: {
    height: 190,
    padding: 0,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
    },
    [theme.breakpoints.up('lg')]: {
      alignItems: 'flex-end',
    },
  },
  chartBarDonutGeneral: {
    padding: '4px'
  },
  titleContract: {
    fontWeight: 700,
    fontSize: '24px',
    color: '#405364',
    lineHeight: '25px',
    marginBottom: '8px'
  },
  descriptionContract: {
    fontWeight: 400,
    fontSize: '16px',
    color: '#405364',
    lineHeight: '25px'
  },
  subtitleContract: {
    fontWeight: 700,
    fontSize: '16px',
    color: '#405364',
    lineHeight: '25px'
  },
  datePicker: {
    padding: '10px 14px',
    border: '1px solid #42526E66',
    boxSizing: 'content-box',
    borderRadius: '16px',
    color: '#034787',
    height: '1.4375em',
    fontWeight: 400,
    fontSize: '1rem',
    width: '70%',
  },
  datePickerPopper: {
    zIndex: 14
  },
  datePickerComplete: {
    padding: '10px 14px',
    border: '1px solid #42526E66',
    boxSizing: 'content-box',
    borderRadius: '16px',
    color: '#034787',
    height: '1.4375em',
    fontWeight: 400,
    fontSize: '1rem',
    width: '82%'
  },
}));

export { useStyles };
